import type { HelpFile } from '../../types/help'
import { FunctionGroupRequestsTestIds } from '../../../testids/FunctionGroupRequestsTestIds'

export const functionGroupRequestsHelp: HelpFile = {
  docPage: '/docs/governance/function-group-requests',
  texts: {
    [FunctionGroupRequestsTestIds.functionGroupRequestsList]:
      'Anträge zum Erteilen oder Entziehen von Funktionsgruppen-Mitgliedschaften — jede Änderung durchläuft vor der Anwendung einen Genehmigungsworkflow.',
    [FunctionGroupRequestsTestIds.btnCreateFgRequest]: 'Neuen Funktionsgruppen-Antrag für eine begünstigte Identität starten.',
    [FunctionGroupRequestsTestIds.colBeneficiary]: 'Die Identität, die die Funktionsgruppen-Mitgliedschaft erhält oder verliert.',
    [FunctionGroupRequestsTestIds.colItems]: 'Anzahl der in diesem Antrag enthaltenen Funktionsgruppen.',
    [FunctionGroupRequestsTestIds.colJustification]: 'Die fachliche Begründung für den Antrag, sichtbar für Genehmigende.',
    [FunctionGroupRequestsTestIds.colRequester]: 'Die Identität, die den Antrag eingereicht hat.',
  },
}
